import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import FoodList from './components/FoodList';
import MenuList from './components/MenuList';
import MenuItemWines from './components/MenuItemWines';
import RegionList from './components/RegionList';
import WineList from './components/WineList';
import WineDetails from './components/WineDetails';
import WineOptions from './components/WineOptions';
import Footer from './components/Footer';
import TenantHeaderMinimal from './components/TenantHeaderMinimal';
import TenantSwitcher from './components/TenantSwitcher';
import ErrorBoundary from './components/ErrorBoundary';
import AnalyticsListener from './components/AnalyticsListener';

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <AnalyticsListener />
        <div className="App app-shell flex flex-col overflow-hidden">
          {/* Header discreto do Tenant */}
          <TenantHeaderMinimal />

          {/* Seletor de Tenant (apenas em desenvolvimento) */}
          <TenantSwitcher />

          <div id="main-scroll-container" className="flex-grow overflow-y-auto">
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/foods" element={<FoodList />} />
              <Route path="/menu" element={<MenuList />} />
              <Route path="/menu/:itemId" element={<MenuItemWines />} />
              <Route path="/regions" element={<RegionList />} />
              <Route path="/wines/:category" element={<WineList />} />
              <Route path="/wines/pairing/:foodId" element={<WineList />} />
              <Route path="/wines/region/:regionId" element={<WineList />} />
              <Route path="/wine/:slug" element={<WineDetails />} />
              <Route path="/wine/:slug/options" element={<WineOptions />} />
            </Routes>
          </div>
          <Footer />
        </div>
      </Router>
    </ErrorBoundary>
  );
}

export default App;

